import styled from 'styled-components';

export const ProductActionsList = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
`;
export default ProductActionsList;
